<template>
	<ux-panel>
		<ux-panel-title>
			<div class="text-caption">Menu</div>
		</ux-panel-title>

		<ul class="ux-icon-menu">
			<li v-for="item in menu" :key="item.text">
				<router-link class="icon-menu-item" :to="item.to">
					<span class="menu-item-icon"><i :class="item.icon"/></span>
					{{ item.text }}
				</router-link>
			</li>
			<li>
				<a href="/logout" class="icon-menu-item">
					<span class="menu-item-icon"><i class="fas fa-sign-out-alt"/></span>
					Log Out
				</a>
			</li>
		</ul>
	</ux-panel>
</template>

<script>
export default {
	data()
	{
		return {
			menu: [
				{ text: 'Profile', icon: 'fas fa-user-circle', to: { name: 'profile-home' } },
				{ text: 'Orders', icon: 'fas fa-receipt', to: { name: 'profile-orders' } },
			]
		}
	}
}
</script>